import moment from 'moment';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { TimeUtilities } from '../../utilities/time-utilities';

export class MeasurementToolsDetailsModel {
    public constructor(
        public technicalId = '',
        public descriptionDropdownText = '',
        public calibratedDate = moment.invalid(),
        public gid = '',
        public message = '',
        public textDescription = '',
    ) {}

    public isToolInvalid(): boolean {
        return !this.calibratedDate.isValid() || this.calibratedDate.isBefore(moment(), 'days');
    }

    public static fromODataMeasurementTools(data: ODataMeasurementToolsModel): MeasurementToolsDetailsModel {
        const date = TimeUtilities.momentFromDateAndTime(data.Mwert1, '');
        return new MeasurementToolsDetailsModel(data.TechIdentNo, data.EquipmentDesc, date, data.FrontId, data.Message);
    }
}

export interface ODataMeasurementToolsModel extends ODataObject {
    __metadata: {
        id: string;
        uri: string;
        type: string;
    };
    TechIdentNo: string;
    FrontId: string;
    EquipmentDesc: string;
    Mwert1: string;
    Message: string;
}
